import { render, staticRenderFns } from "./ResourceBookingBox.vue?vue&type=template&id=6f00e3d5&"
import script from "./ResourceBookingBox.vue?vue&type=script&lang=js&"
export * from "./ResourceBookingBox.vue?vue&type=script&lang=js&"
import style0 from "./ResourceBookingBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports